/**
 * Civil Defence: harder to finish off once you are already on the floor.
 *
 * The seed instance for a lever that only matters in the worst moment. The issue names it, and it
 * is the clearest case for conditions existing at all: unconditionally, a tenth off incoming damage
 * is a dull number, and while downed it is the difference between a team mate arriving in time and
 * arriving.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const CIVIL_DEFENCE = {
  id: 'civilDefence',
  branch: 'survival',
  tier: 1,
  title: 'Civil Defence',
  blurb: 'Duck. Cover. Remain calm and await the all clear, which has not yet been given.',
  maxRanks: 3,
  minLevel: 3,
  requires: [],
  statGrants: {},
  effects: [{ field: 'incomingDamage', perRank: -0.09, condition: 'whileDowned' }],
  damageModifiers: [],
} as const satisfies Perk;
